import React, { lazy, Suspense } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
// import glocalData from '@/store/index'

const routes = [
    {
        path: "/",
        element: lazy(() => import('@/pages/home/index')),
    },
    {
        path: "/test/*",
        element: lazy(() => import('@/pages/test/index')),
        children:[
            {
                index:true,
                element: lazy(() => import('@/pages/test/page1/index')),
            },
            {
                path: "page2",
                element: lazy(() => import('@/pages/test/page2/index')),
            }
        ]
    },
    {
        path: "*",
        notHandle: true,
        element: <Navigate to="/" />, //404 或者首页
    },
]

const handleRoute = (routes) => {
    let tmpRoutes = [];
    routes.forEach(route => {
        tmpRoutes.push(
            {
                ...route,
                element: route.notHandle ? route.element : (
                    <Suspense fallback={<div>loading...</div>}>
                        <route.element />
                        {/* <route.element store={glocalData} /> */}
                    </Suspense>
                ),
                children: route.children && handleRoute(route.children)
            }
        );
    })
    return tmpRoutes;
}

const AllRoute = () => useRoutes(handleRoute(routes))

export default AllRoute